import "./VO2MaxMetabolicTesting.module.css";
import Header from "@/reusable_sections/Header";
import Vo2MetabolicHero from "./sections/Vo2MetabolicHero";
import MetabolicComparison from "./sections/MetabolicComparison";
import MetabolicFeatures from "./sections/MetabolicFeatures";
import Vo2Pricing from "./sections/Vo2Pricing";
import ApplicationsOverview from "./sections/ApplicationsOverview";
import TestingWalkthrough from "./sections/TestingWalkthrough";
import TestPreparationGuidance from "./sections/TestPreparationGuidance";
import TestingSuitability from "./sections/TestingSuitability";
import MeasuredDataComparison from "./sections/MeasuredDataComparison";
import TrainingDecisions from "./sections/TrainingDecisions";
import EnergyOverview from "./sections/EnergyOverview";
import MovementContext from "./sections/MovementContext";
import PerformanceAssessmentPromo from "./sections/PerformanceAssessmentPromo";
import TestingAvailability from "./sections/TestingAvailability";
import FaqAccordion from "./sections/FaqAccordion";
import MetabolicAssessmentCta from "./sections/MetabolicAssessmentCta";
import HealthyAgeing from "./sections/HealthyAgeing";
import Footer from "@/reusable_sections/Footer";
export default function VO2MaxMetabolicTestingPage() {
  return <div>
      <Header />
      <Vo2MetabolicHero />
      <MetabolicComparison />
      <MetabolicFeatures />
      <Vo2Pricing />
      <ApplicationsOverview />
      <TestingWalkthrough />
      <TestPreparationGuidance />
      <TestingSuitability />
      <MeasuredDataComparison />
      <TrainingDecisions />
      <EnergyOverview />
      <MovementContext />
      <PerformanceAssessmentPromo />
      <TestingAvailability />
      <FaqAccordion />
      <HealthyAgeing />
      <MetabolicAssessmentCta />
      <Footer />
    </div>;
}